import { useEffect, useState, useRef } from 'react';
import { Box, TextField, Autocomplete, Stack, Typography} from '@mui/material';
import { Text } from 'mbd-components/text';
import { EndpointTag } from 'mbd-components/endpoint-tag';

export function FeedSelector({feeds, templateFeeds, filterOutFeedIds, selectedFeedId, onChange}) {

  const [currentValue, setCurrentValue] = useState(null);
  const userInteractionRef = useRef(false);

  useEffect(() => {
    if (selectedFeedId && !userInteractionRef.current) {
      setCurrentValue(filterOutFeedIds?.includes(selectedFeedId) ? null : feeds.find(feed => feed.config_id === selectedFeedId) );
    }
    userInteractionRef.current = false;
  }, [selectedFeedId, filterOutFeedIds, feeds]);

  let allFeeds = [
    ...feeds.sort((a, b) => {
      const numA = parseInt(a.config_id.split('_')[1], 10);
      const numB = parseInt(b.config_id.split('_')[1], 10);
      return numB - numA; // Descending order
    }), 
    ...(templateFeeds || [])
  ];
  
  if (filterOutFeedIds?.length > 0) {
    allFeeds = allFeeds.filter(feed => !filterOutFeedIds.includes(feed.config_id));
  }

  return (
    <Autocomplete
      fullWidth
      value={currentValue}
      onChange={(event, newValue) => {
        console.log('newValue', newValue);
        userInteractionRef.current = true;
        setCurrentValue(newValue);
        if (newValue) {
          onChange(newValue);
        } else {
          // Handle clearing the selection
          onChange(null);
        }
      }}
      options={allFeeds}
      getOptionLabel={(option) => {
        if (!option) return '';
        return option.name + ' (' + option.config_id + ')';
      }}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        return option.config_id === value.config_id;
      }}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" margin="dense" />
      )}
      renderOption={(props, option) => 
        <Box {...props} px={2} py={1}>
          <Stack direction='column' spacing={1}>
          <Typography variant="body1" fontWeight="medium">{option.name}</Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }} alignItems={'flex-start'} justifyContent={'flex-start'} justifyItems={'flex-start'}>
            <Typography variant="caption" color="text.secondary" textAlign={'left'}>ID: {option.config_id}</Typography>
            <Typography variant="caption" color="text.secondary" textAlign={'left'}>Endpoint: </Typography>
            <EndpointTag endpoint={option.endpoint}/>
          </Box>
          </Stack>
        </Box>
      }
    />
  );
}